"use client";

import { useEffect, useState } from "react";
import {
  selectPublicationStatusKind,
  type PublicationStatusInput,
} from "../components/publicationFlow/publicationStatusPresentation";
import { toValidDate } from "../utils/date";

/** Refresh at the scheduled time even when no query or parent changes. */
export function usePublicationStatusKind(publication: PublicationStatusInput) {
  const [now, setNow] = useState(() => new Date());
  const scheduledTime = toValidDate(publication.scheduledAt)?.getTime();

  useEffect(() => {
    if (publication.status !== "scheduled" || scheduledTime == null) return;
    let timer: ReturnType<typeof setTimeout>;
    const refresh = () => {
      const current = new Date();
      setNow(current);
      const delay = scheduledTime - current.getTime();
      // Recheck distant dates daily to stay below the browser timer limit.
      if (delay > 0) timer = setTimeout(refresh, Math.min(delay, 86_400_000));
    };
    // A Post now write can arrive between timer ticks.
    refresh();
    return () => clearTimeout(timer);
  }, [publication.status, scheduledTime]);

  return selectPublicationStatusKind(publication, now);
}
